import type {BindingSource} from '@packages/systems/dynamo/gateway';
import type {FauxBindingSource} from '@packages/systems/dynamo/utils/ParamPanelUtils';

export function getOptionOptions(
  bindingSource: BindingSource | FauxBindingSource
) {
  return bindingSource.type === 'Option' ? bindingSource.meta.options : [];
}
